import CSVButton from 'admin/components/shared/CSVButton';
import moment from 'moment';
import React from 'react';
import { CSVLink } from 'react-csv';
import styled from 'styled-components';

type CSVData = React.ComponentPropsWithoutRef<typeof CSVLink>['data'];
type CSVHeaders = React.ComponentPropsWithoutRef<typeof CSVLink>['headers'];

type Props = {
  csvFilePrefix: string;
  numberOfData?: number;
  numberOfDataMax?: number;
  fetchData: () => CSVData | Promise<CSVData>;
  hideDescription?: boolean;
  csvHeaders?: CSVHeaders;
  className?: string;
  text?: string;
  customDownloadBehaviour?: (downloadCsv: () => Promise<void>) => unknown;
};

const FormWrapper = styled.div`
  display: flex;
  padding: 5px;
  margin: 10px;
`;

const CSVDownloadButton = ({
  csvFilePrefix,
  fetchData,
  csvHeaders,
  className,
  text,
  customDownloadBehaviour,
}: Props) => {
  const csvFileName = `${csvFilePrefix}${moment().format('YYYYMMDDHHmmss')}.csv`;
  return (
    <FormWrapper className={className}>
      <CSVButton
        fetchData={fetchData}
        fileName={csvFileName}
        headers={csvHeaders}
        text={text}
        customDownloadBehaviour={customDownloadBehaviour}
      />
    </FormWrapper>
  );
};

export default CSVDownloadButton;
